// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"5b55cf11","800":"5b55cf11"}[chunkId] + ".chunk.css";
};